export default {
  // 标题
  verificationResult: "验证结果",
  modelVerification: "模型验证",

  // 验证统计
  currentSuccess: "当前{count}个验证成功；",
  hasFailed: "有{count}个验证失败；",
  hasNoNeed: "有{count}个是平台地址不需要模型验证。",

  // 暂无数据
  noData: "暂无数据",

  // 加载提示
  loading: "拼命加载中",

  // 基本信息
  basicInfo: "基本信息",
  caseName: "案件名称",
  canvasName: "画布名称",
  creator: "创建人",
  createTime: "创建时间",
  status: "状态",
  verified: "已验证",
  toBeVerified: "待验证",
  model: "模型",
  feeModel: "手续费模型",

  // 验证结果详情
  verificationResultTitle: "验证结果",
  firstFeeSourcePlatform: "首笔手续费来源平台",
  firstFeeSourceLevel: "首笔手续费来源层级",
  feeSourceLevel: "手续费来源层级",
  firstFeeSourceQuantity: "首笔手续费来源数量",
  firstFeeSourceTime: "首笔手续费来源时间",
  firstFeeSourceAddress: "首笔手续费来源地址",
  feeSourceAddress: "手续费来源地址",
  firstFeeSourceHash: "首笔手续费来源hash",
  feeSourceHash: "手续费来源hash",
  feeSourceTime: "手续费来源时间",
  feeSourceQuantity: "手续费来源数量",

  // 操作
  addToSurvey: "+加入调证",
  addToSurveySuccess: "加入调证成功",
  copySuccess: "复制成功",
  browserNotSupport: "该浏览器不支持自动复制",
};
